import {CountTriggerTextViewerCoreOption} from '../type/CountTriggerTextViewerCoreOption.interface';
import {FrameElements} from '../type/FrameElements.interface';
import {getPageTextViewerSizes} from './getPageTextViewerSizes';

/**
 * 특정 페이지를 보여주기 위해 컨텐트 위치를 적용하는 함수
 */
export function applyPage({
  frameElements,
  page,
  option,
}: {
  frameElements: FrameElements;
  page: number;
  option: CountTriggerTextViewerCoreOption;
}) {
  const {contentElement} = frameElements;

  const {onePageOffset} = getPageTextViewerSizes(option);
  const left = -1 * onePageOffset * page;

  contentElement.style.left = `${left}px`;
}
